//v-visible
const visible = (el,
    binding,
    vnode,
    oldVnode) => el.style.visibility = (binding.value) ? "" : "hidden";

export default {
    bind: visible,  
    update: visible,
}